export const TENANT_MODULES = Object.freeze({
  OFFER_PRODUCTS: "offer_products",
  NEWS: "news",
  CAMPAIGNS: "campaigns",
  INVOICE_MILESTONE: "invoice_milestone",
  PUSH_NOTIFICATIONS: "push_notifications",
  ADVANCED_PUSH_NOTIFICATIONS: "advanced_push_notifications",
});

export const getTenantModules = (appConfig) =>
  appConfig?.features?.modules ?? {};

export const isTenantModuleEnabled = (modules, moduleKey) =>
  modules?.[moduleKey] === true;
